import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { UserGroupsComponent } from './components/user-groups/user-groups.component';
import { SensorGroupsComponent } from './components/sensor-groups/sensor-groups.component';
import { TriggerSettingsComponent } from './components/trigger-settings/trigger-settings.component';
import { SensorReadingsComponent } from './components/sensor-readings/sensor-readings.component';
import { MapReadingsComponent } from './components/map-readings/map-readings.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { RegisterDevicesComponent } from './components/register-devices/register-devices.component';
import { PostLoginComponent } from './components/post-login/post-login.component';
import { SensorsComponent } from './components/sensors/sensors.component';
import { MessagesComponent } from './components/messages/messages.component';
import { UsersComponent } from './components/users/users.component';
import { ImportComponent } from './components/import/import.component';
import { ScoutviewComponent } from './components/scoutview/scoutview.component';
import { HomeComponent } from './components/home/home.component';
import { ReviewReadingsComponent } from './components/review-readings/review-readings.component';
import { ActionQueuesComponent } from './components/trigger-queues/action-queues.component';

const appRoutes: Routes = [
  { path: 'home', component: HomeComponent, canActivate: [ MsalGuard ] },
  { path: 'postlogin', component: PostLoginComponent },
  { path: 'users', component: UsersComponent, canActivate: [MsalGuard] },
  { path: 'usergroups', component: UserGroupsComponent, canActivate: [MsalGuard] },
  { path: 'sensors', component: SensorsComponent, canActivate: [ MsalGuard ] },
  { path: 'sensorgroups', component: SensorGroupsComponent, canActivate: [ MsalGuard ] },
  { path: 'events', component: TriggerSettingsComponent, canActivate: [ MsalGuard ] },
  { path: 'actionqueues', component: ActionQueuesComponent, canActivate: [ MsalGuard ] },
  { path: 'events/manualflood/:id', component: TriggerSettingsComponent, canActivate: [ MsalGuard ] },
  { path: 'events/:id', component: TriggerSettingsComponent, canActivate: [ MsalGuard ] },
  { path: 'dashboard/:id', component: DashboardComponent, canActivate: [ MsalGuard ] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [ MsalGuard ] },
  { path: 'messages', component: MessagesComponent, canActivate: [ MsalGuard ] },
  { path: 'register', component: RegisterDevicesComponent, canActivate: [ MsalGuard ] },
  { path: 'chartreadings/:id', component: SensorReadingsComponent, canActivate: [ MsalGuard ] },
  { path: 'chartreadings', component: SensorReadingsComponent, canActivate: [ MsalGuard ] },
  { path: 'mapreadings', component: MapReadingsComponent, canActivate: [ MsalGuard ] },
  { path: 'import', component: ImportComponent, canActivate: [ MsalGuard ] },
  { path: 'scoutview', component: ScoutviewComponent, canActivate: [ MsalGuard ] },
  { path: 'sensorreadings', component: ReviewReadingsComponent, canActivate: [ MsalGuard ] },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', redirectTo: '/home', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {})
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
